module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-9c1df2fd.png";